module.exports = __webpack_public_path__ + "img/icon-chat.cbac755c.svg";